module.exports = __webpack_public_path__ + "img/android1icon3.18009383.png";